import React from 'react'

export interface SpinnerProps {
  /** Size in pixels (width and height) */
  size?: 'sm' | 'md' | 'lg'
  /** Color class -- defaults to currentColor */
  className?: string
  /** Accessible label for screen readers */
  label?: string
}

/**
 * Spinner -- standalone loading indicator.
 *
 * Three sizes: sm (16px), md (24px), lg (32px).
 * Inherits text color from parent by default.
 */
export const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  className = '',
  label = 'Loading...',
}) => {
  const sizeMap = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
  }

  const announced = label.trim().length > 0

  return (
    <svg
      className={`animate-spin ${sizeMap[size]} ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      role={announced ? 'status' : 'presentation'}
      aria-label={announced ? label : undefined}
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
  )
}
